
export {ClayPaginationBarWithBasicItems,
PaginationBar,
DropDown,
Results} from '@clayui/pagination-bar';
import __x__ from '@clayui/pagination-bar';export default __x__;